<script>
import { required } from "vuelidate/lib/validators";
import Loader from "../widgets/loader.vue";

// Custom Components
import DataUpdateInfo from "@/components/dataUpdateInfo.vue";
import PbxService from "@/helpers/APIService/pbx.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";

export default {
  data() {
    return {
      pbx_serve_form: {
        server_name: "",
        server_ip: "",
        security_group_id: "",
        security_group_name: "",
      },
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
      isLoadingEdit: false,
      dataToBeUpdate: {},
    };
  },
  props: {
    pbxServerId: Number,
    isEdit: Boolean,
  },
  emits: ["submitted", "cancelSubmit"],
  validations: {
    pbx_serve_form: {
      server_name: { required },
      server_ip: { required },
      security_group_id: { required },
      security_group_name: { required },
    },
  },
  components: {
    DataUpdateInfo,
    Loader,
  },
  mounted() {
    this.setValue();
  },
  methods: {
    // Method is sued to set value
    setValue() {
      if (this.isEdit == true) {
        this.isLoadingEdit = true;
        PbxService.getPBXServerDetail(this.pbxServerId)
          .then((response) => {
            const pbxServerDetails = response.result;
            Object.keys(pbxServerDetails).map((key) => {
              if (
                pbxServerDetails[key] !== null ||
                pbxServerDetails[key] !== undefined
              ) {
                this.pbx_serve_form[key] = pbxServerDetails[key];
              }
            });
            this.isLoadingEdit = false;
            this.dataToBeUpdate = {
              created_by: pbxServerDetails.created_by,
              created_at: pbxServerDetails.created_at,
              updated_by: pbxServerDetails.updated_by,
              updated_at: pbxServerDetails.updated_at,
            };
          })
          .catch((error) => {
            this.isLoadingEdit = false;
            errorHandler(error);
          });
      }
    },
    // Method is used to handle submit of form
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let data = {};
        Object.keys(this.pbx_serve_form).map((key) => {
          if (
            this.pbx_serve_form[key] !== null &&
            this.pbx_serve_form[key] !== undefined
          ) {
            data[key] = this.pbx_serve_form[key];
          }
        });
        if (this.isEdit) {
          PbxService.updatePBXServerDetail(this.pbxServerId, data)
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "danger");
              }
              Middleware.notification("Successfully Updated !!", "success");
              this.$emit("submitted", response.result);
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              errorHandler(error);
            });
        } else {
          PbxService.addPBXServerDetail(data)
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "danger");
              }
              Middleware.notification("Successfully added !!", "success");
              this.$emit("submitted", response.result);
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ isEdit ? "Update" : "Add New" }} PBX server</h4>
        <hr />
        <div class="row">
          <div class="col-sm-6">
            <b-form-group class="mb-3" label-for="server_name">
              <span slot="label">
                pbx Name <span class="text-danger">*</span></span
              >
              <b-form-input
                id="server_name"
                type="url"
                autocomplete="off"
                v-model="pbx_serve_form.server_name"
                :class="{
                  'is-invalid':
                    submitted && $v.pbx_serve_form.server_name.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_serve_form.server_name.required"
                  >Pbx server name is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group class="mb-3" label-for="ip">
              <span slot="label"> IP <span class="text-danger">*</span></span>
              <b-form-input
                id="ip"
                type="text"
                autocomplete="off"
                v-model="pbx_serve_form.server_ip"
                :class="{
                  'is-invalid': submitted && $v.pbx_serve_form.server_ip.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_serve_form.server_ip.required"
                  >Ip is required.</span
                >
              </div>
            </b-form-group>
          </div>

          <div class="col-sm-6">
            <b-form-group class="mb-3" label-for="security_group_name">
              <span slot="label">
                Security Group Name <span class="text-danger">*</span></span
              >
              <b-form-input
                id="security_group_name"
                type="text"
                autocomplete="off"
                v-model="pbx_serve_form.security_group_name"
                :class="{
                  'is-invalid':
                    submitted && $v.pbx_serve_form.security_group_name.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_serve_form.security_group_name.required"
                  >Security Group name is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group class="mb-3" label-for="security_group_id">
              <span slot="label">
                Security Group Id <span class="text-danger">*</span></span
              >
              <b-form-input
                id="security_group_id"
                type="text"
                autocomplete="off"
                v-model="pbx_serve_form.security_group_id"
                :class="{
                  'is-invalid':
                    submitted && $v.pbx_serve_form.security_group_id.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_serve_form.security_group_id.required"
                  >Security group id is required.</span
                >
              </div>
            </b-form-group>
          </div>

          <div class="col-sm-12">
            <b-alert v-if="isError" show variant="danger">
              <ul>
                <li v-for="(error, index) in errorMessage" :key="index">
                  {{ index }}: {{ error[0] }}
                </li>
              </ul>
            </b-alert>
          </div>

          <div class="col-sm-12">
            <b-button
              class="float-end ms-2 mb-3"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              class="float-end mb-3"
              variant="outline-primary"
              type="submit"
              @click="onSubmit"
              :class="{
                disabled: isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
          <DataUpdateInfo :data-to-be-show="dataToBeUpdate" />
        </div>
        <Loader :loading="{ isLoading: isLoadingEdit }" />
      </div>
    </div>
  </div>
</template>
